import React from "react";
import { t } from "i18next";
import InitialIcon from "@material-ui/icons/AssignmentOutlined";
import { makeThemedStyles } from "./../../viewcomponents/utils";
const useStyles = makeThemedStyles("MilestoneInput.Definitions", (theme) => ({
  initialText: {
    marginTop: "150px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    opacity: 0.2,
  },
}));
const TextSelectProjectFromList = (props: { isKpi?: boolean }) => {
  const { isKpi } = props;
  const classes = useStyles();
  return (
    <div className={classes.initialText}>
      <InitialIcon
        style={{ width: "70px", height: "70px", color: "#40848a" }}
      />
      <div>
        {isKpi
          ? t("Select kpi from the list on left")
          : t("Select project from the list on left")}
      </div>
    </div>
  );
};
export default TextSelectProjectFromList;
